import HeatmapFilterModal from './HeatmapFilterModal';

export default HeatmapFilterModal;
